import { API_JWT_BASE_URL } from '../http'

export const GET_FIRMWARE_RELEASES_API = `${API_JWT_BASE_URL}/Firmware`
// export const GET_CUSTOMIZATION_PROFILES_API = `${API_V2_BASE_URL}/customizationprofiles`
// export const GET_CUSTOMIZATION_PROFILES_SUMMARY_API = `${API_V2_BASE_URL}/customizationprofiles/summary`
export const GET_CALIBRATION_APPLICATIONS_API = `${API_JWT_BASE_URL}/SupportingApplications/CalibrationApplications`
export const GET_PROGRAMMING_APPLICATIONS_API = `${API_JWT_BASE_URL}/SupportingApplications/ProgrammingApplications`

export const CONFIGURATION_QUERY_KEYS = {
  GET_FIRMWARE_RELEASES: 'getFirmwareReleases',
  GET_SUPPORTED_FEATURES: 'getSupportedFeatures',
  GET_CUSTOMIZATION_PROFILES: 'getCustomizationProfiles',
  GET_CUSTOMIZATION_PROFILES_SUMMARY: 'getCustomizationProfilesSummary',
  GET_CALIBRATION_APPLICATIONS: 'getCalibrationApplications',
  GET_PROGRAMMING_APPLICATIONS: 'getProgrammingApplications'
}
